import { Visit } from './../../../../models/visit.interface';
import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { DebitoAbertoInformacaoComponent } from '../debito-aberto-informacao/debito-aberto-informacao.component';
import { ClientesService } from '@modules/clientes/services/clientes.service';
import { OnChanges, SimpleChanges } from '@angular/core';


@Component({
  selector: 'app-visits-important-info',
  templateUrl: './visits-important-info.component.html',
  styleUrls: ['./visits-important-info.component.scss']
})
export class VisitsImportantInfoComponent implements OnInit {

  setorCdFzs = null;
  vetorSetor: any;
  userLogado;
  isRequesting: Boolean = false;
  parameters: any;
  lsClients: any[] = [];

  @ViewChild('visitsImportantInfoComponent', {static: true}) private visitsImportantInfoComponent: ModalComponent;
  @ViewChild(DebitoAbertoInformacaoComponent, {static: true}) debitoAbertoInformacaoComponent: DebitoAbertoInformacaoComponent;
  
  @Output() markClick = new EventEmitter()
  @Output() cancelClick = new EventEmitter()
  @Input() visitsWithImportantInfo: Visit[] = [];

  constructor(
    private clientService: ClientesService,
  ) { }

  ngOnInit() {
    console.log('chegou');
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.visitsWithImportantInfo) {
      console.log('Novo array recebido:', this.visitsWithImportantInfo);
    }
  }

  public open(){
    this.isRequesting = true;
    this.visitsImportantInfoComponent.open()
    console.log('array', this.visitsWithImportantInfo);
  }

  public close(){
    console.log('array', this.visitsWithImportantInfo);
    this.cancelClick.emit(this.visitsWithImportantInfo);
    this.visitsImportantInfoComponent.close();
  }

  public handleMarkClick(){
    // this.close()
    this.markClick.emit();
    this.visitsImportantInfoComponent.close();
  }

  openNewScreenTableDebitoAberto(){
    var teste = "";
    teste = "clicou";
    console.log("passou no click");
    console.log("caminho", window.location.origin + '/svc/api' );
    window.open(window.location.origin + "/visitas/debito-aberto-carteira-info?cnpj="+this.visitsWithImportantInfo[0].cnpj, "minhaJanela", "height=600,width=600");
    //this.debitoAbertoInformacaoComponent.open()

  }

  makeVisit() {
    console.log("passou no makeVisit")
  }

  
}
